import type { Enrichment } from '@aibees/shared/definition';

export interface EnrichmentSearchTableActionProps {
  className?: string;
  item: Enrichment;
}

export enum EnrichmentSearchActionType {
  edit = 'edit',
  retry = 'retry',
  copyId = 'copyId',
}
